'use strict';

export default function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('oem_main.oem_user_edit', {
    url: '/user_edit/:id',
    template: '<oem-user-edit></oem-user-edit>'
  });
};



// WEBPACK FOOTER //
// ./public/dev/app/oem/oem_user/edit/oem_user_edit.routes.js